import React from "react";

/**
 * Shared circular loading spinner used across demo iframes and app loading states.
 * @param {Object} props
 * @param {"light"|"dark"|"onPrimary"} [props.tone] - light = slate/blue (light bg), dark = white/accent (dark bg), onPrimary = white (blue buttons)
 * @param {"sm"|"md"} [props.size] - sm = 8 (32px), md = 12 (48px)
 * @param {string} [props.className] - Extra classes for the wrapper
 */
export function LoadingSpinner({ tone = "light", size = "md", className = "" }) {
  const sizeClass = size === "sm" ? "h-8 w-8" : "h-12 w-12";
  const borderClass =
    tone === "dark"
      ? "border-white/20 border-t-accent"
      : tone === "onPrimary"
        ? "border-white/30 border-t-white"
        : "border-slate-200 border-t-blue-500";

  return (
    <div
      className={`animate-spin rounded-full border-2 ${sizeClass} ${borderClass} ${className}`.trim()}
      role="status"
      aria-label="Loading"
    />
  );
}

export default LoadingSpinner;
